export const dslTranslationsSectionMessagesEn = {
  // Cohort Builder - CohortDefinitionDSLSection
  'projects.cohortBuilderPage.cohortDefinitionDSLSection.title': 'Cohort definition DSL',
  'projects.cohortBuilderPage.cohortDefinitionDSLSection.noDSLMainMsg': 'No DSL value',
  'projects.cohortBuilderPage.cohortDefinitionDSLSection.noDSLSubMsg':
    'Define a variable to view the DSL.',

  // Cohort Builder - CohortDefinitionSQLSection
  'projects.cohortBuilderPage.cohortDefinitionSQLSection.title': 'Cohort definition SQL',
  'projects.cohortBuilderPage.cohortDefinitionSQLSection.noSQLMainMsg': 'No SQL value',
  'projects.cohortBuilderPage.cohortDefinitionSQLSection.noSQLSubMsgRestricted':
    'Add an index date or a criterion to view the SQL.',
  'projects.cohortBuilderPage.cohortDefinitionSQLSection.translating': 'Generating SQL...',
  'projects.cohortBuilderPage.cohortDefinitionSQLSection.translatingSubMessage':
    'Please wait while the SQL is generated.',
  'projects.cohortBuilderPage.cohortDefinitionSQLSection.error': 'Error generating SQL',
  'projects.cohortBuilderPage.cohortDefinitionSQLSection.errorSubMessage':
    'There was an error generating the SQL. Please try again.',

  // Cohort Builder - CohortDefinitionDSLToUISection
  'projects.cohortBuilderPage.cohortDefinitionDSLToUISection.title': 'Cohort definition DSL to UI',
};
